import styled from 'styled-components';
import { Form } from 'antd';
import { COLOR_NEUTRAL_4 } from 'constants/colors';

export const FormContainer = styled(Form)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  border-top: 1px solid ${COLOR_NEUTRAL_4};
  padding-top: 1.5rem;
  width: 100%;
`;

export const BaseFormItem = styled(Form.Item)`
  margin: 0;
  min-width: 215px;

  & .ant-col,
  & .ant-form-item-control {
    width: 100%;
    max-width: 376px;
  }
`;

export const HorizontalContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1.5rem;
  align-items: center;
  padding-bottom: 1.5rem;
`;
